import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppBar, { appBarHeight, FloatingHomeSwitch } from "@/components/@common/AppBar";
// TODO: @genie 커스텀 채널톡 버튼 - 다음 스프린트에서 작업 예정
// import ChannelTalkButton from '@/components/@common/ChannelTalkButton'
import ExpertGNB from "@/components/common/GNB/ExpertGNB";
import MarketGNB from "@/components/common/GNB/MarketGNB";
import SolvookAppLayout from "@/components/solvookApp/common/SolvookAppLayout";
import Footer from "@/containers/Layout/Footer";
import { useAppBar } from "@/hooks/useAppBar";
import { cn } from "@/lib/utils";
import { ADMIN_PAGE_LOGIN, EDITION_CATEGORY_PAGE, MYPAGE_STORES_PRODUCTS_NEW_INDEX, PUBLISHER_LOGIN, SOLVOOK_APP_PAGE, VIEWER_PAGE, VIEWER_PRINTOUT_PAGE } from "@/settings/constant";
import { Layout } from "antd";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import * as React from "react";
import { useMemo } from "react";
import { isInWebview, useMounted } from "src/utils/misc";
export const MobileOnlyHeaderHeight = "64px";
export const mobileTabBarHeight = "0";
// 하위 호환성을 위해 re-export
export { appBarHeight };
const { Content  } = Layout;
export const LayoutContainer = observer((param)=>{
    let { children  } = param;
    const router = useRouter();
    const { pathname , query  } = router;
    const { items: appBarItems , activeKey: appBarActiveKey  } = useAppBar();
    const { isUseFooter  } = useMemo(()=>({
            isUseFooter: !isInWebview()
        }), []);
    const withoutLayoutPages = [
        VIEWER_PRINTOUT_PAGE,
        VIEWER_PAGE,
        MYPAGE_STORES_PRODUCTS_NEW_INDEX,
        ADMIN_PAGE_LOGIN,
        PUBLISHER_LOGIN
    ];
    const isViewerPages = /\/viewer\//.test(pathname);
    const isSolvookAppPage = pathname.startsWith(SOLVOOK_APP_PAGE);
    const productEditPage = /\/products\/(.*)\/edit/.test(pathname);
    const receiptPage = /\/receipt\//.test(pathname);
    const expertPage = pathname.includes("/expert");
    const mounted = useMounted();
    // 앱바를 숨길 페이지
    const productDetailPage = /^\/products\/[^/]+$/.test(pathname);
    const checkoutPage = pathname.startsWith("/shop/checkout");
    const editionCategoryPage = pathname.startsWith(EDITION_CATEGORY_PAGE);
    const hideAppBar = productDetailPage || checkoutPage || editionCategoryPage;
    const renderGNB = useMemo(()=>{
        // SSR hydration 불일치 방지: 마운트 전에는 GNB를 렌더링하지 않음
        if (!mounted) return null;
        if (expertPage) return /*#__PURE__*/ _jsx(ExpertGNB, {});
        return /*#__PURE__*/ _jsx(MarketGNB, {});
    }, [
        mounted,
        pathname
    ]);
    if (withoutLayoutPages.includes(pathname) || isViewerPages || productEditPage || receiptPage) {
        return /*#__PURE__*/ _jsx(Content, {
            children: children
        });
    }
    if (isSolvookAppPage) {
        return /*#__PURE__*/ _jsx(Content, {
            children: /*#__PURE__*/ _jsx(SolvookAppLayout, {
                children: children
            })
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        id: "layout-scroll-container",
        className: cn("flex min-h-screen flex-col bg-white", "[&_.ant-layout-content]:flex [&_.ant-layout-content]:flex-col", // GNB 뱃지 숨김 (레거시)
        "[&_.gnb_h1_.MuiBadge-badge]:hidden"),
        children: [
            isUseFooter && renderGNB,
            /*#__PURE__*/ _jsx(Content, {
                children: children
            }),
            isUseFooter && /*#__PURE__*/ _jsx(Footer, {}),
            isUseFooter && /*#__PURE__*/ _jsx(FloatingHomeSwitch, {}),
            isUseFooter && !hideAppBar && /*#__PURE__*/ _jsx(AppBar, {
                items: appBarItems,
                activeKey: appBarActiveKey
            })
        ]
    });
});
